"use client";

import React, { useEffect, useState } from "react";
import styles from "./transaction-pending-indicator.module.scss";
import LoadingIcon from "@/components/layout/loading-icon";
import { AnimatePresence, motion } from "framer-motion";
import useDotsLoader from "@/hooks/useDotsLoader.hook";
import { useUIStore } from "@/stores/ui-states.store";

const TransactionPendingIndicator = () => {
  const isTxPending = useUIStore((state) => state.pendingTxns.length);
  const dots = useDotsLoader();

  return (
    <AnimatePresence>
      {isTxPending && (
        <motion.div
          initial={{ x: -20, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -20, opacity: 0 }}
          className={styles.pendingContainer}
        >
          <LoadingIcon size={30} />
          <span>Transaction pending{dots}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TransactionPendingIndicator;
